import { render } from "./captha.vue?vue&type=template&id=56921388&scoped=true"
import script from "./captha.vue?vue&type=script&lang=js"
export * from "./captha.vue?vue&type=script&lang=js"

import "./captha.vue?vue&type=style&index=0&id=56921388&scoped=true&lang=less"

import exportComponent from "E:\\Object\\xin_poc_mini\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56921388"]])

export default __exports__